import { Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { NotificationProvider } from 'src/features/notification/index';
import ErrorBoundary from 'src/features/error/components/error-boundary';
import Topbar from '../topbar/top-bar';

export default function AppLayout() {
    return (
        <ErrorBoundary>
            <NotificationProvider>
                <Topbar />
                <Container maxWidth={false}>
                    <Outlet />
                </Container>
            </NotificationProvider>
        </ErrorBoundary>
    );
}
